import moment from "moment";
import logo from "../../assets/images/kmLogo.png";

const UserPDF = (data, cityName, machineTime) => {
  // Format the date with time in AM/PM format
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  let tableRows = "";
  const currentDate = moment().tz("Asia/Tokyo").format("DD-MM-YYYY hh:mm A");
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const browserCity = cityName || browserTimeZone.split("/").pop().replace(/_/g, " ");
  const localTime = machineTime || moment().format("Do MMMM hh:mma");

  let serialNumber = 1;

  data.forEach((item) => {
    const date = moment.utc(item.AUCTION_DATE);
    const formattedDate = date.format("Do MMM hh:mma");
    const formattedNumber = numberWithCommas(parseInt(item.bids[0].amount));
    let note = "";
    if (item?.bids[0]?.bidNote) {
      note = item?.bids[0]?.bidNote;
    }
    let group = "";
    if (item.bids[0]?.bidGroup) {
      group = "Yes";
    } else {
      group = "No";
    }
    const limitedStr = note.substring(0, 10);
    tableRows += `
            <tr>
                <td>${serialNumber}</td>
                <td class="nowrap">
                    ${item.bids[0].userId.FirstName} ${item.bids[0].userId.LastName}${note ? `<span class="sub"> &middot; ${note}</span>` : ""}
                </td>
                <td>${item.LOT}</td>
                <td class="nowrap">
                    ${item.MARKA_NAME}<span class="sub"> ${item.MODEL_NAME}</span>
                </td>
                <td>${item.YEAR}</td>
                <td class="nowrap">&yen;${formattedNumber}</td>
                <td class="nowrap">
                    ${item.AUCTION}<span class="sub"> ${formattedDate}</span>
                </td>
                <td>${group}</td>
                <td>${item.bids[0].status}</td>
            </tr>
        `;
    serialNumber++; // Increment serial number
  });

  return `
    <!DOCTYPE html>
    <html lang="en">

    <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        @page {
        margin: 8mm 6mm;
        }

        body {
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        font-size: 14px;
        }

        .info-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        }

        .box {
        width: 33%;
        }

        .boxDivs {
        padding: 2px 0px;
        }

        table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        margin-top: 6px;
        font-size: 14px;
        }

        thead {
        display: table-header-group; /* repeat header on every page */
        }

        tr {
        page-break-inside: avoid;
        }

        .tHeadColor, th {
        background-color: #CC071A;
        color: #fff;
        font-size: 13px;
        padding: 4px 4px;
        }

        th,
        td {
        border: 1px solid #ccc;
        padding: 3px 4px;
        text-align: left;
        line-height: 1.15;
        vertical-align: middle;
        }

        tbody tr td {
        font-size: 14px;
        }

        /* Secondary text (model, date, note) kept on the same line, smaller */
        .sub {
        font-size: 12px;
        color: #444;
        }

        /* Keep single-line cells from wrapping into 2-3 lines */
        td.nowrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    </style>
    </head>

    <body>
    <div class="info-container" style="margin-bottom: 6px;">
        <div style="width: 60%;">
        <h1 style="color: #ccc; font-size: 23px; margin: 0;">Users Bid List</h1>
        </div>
        <div style="width: 22%; text-align: right;">
        <img src=${logo} alt="Company Logo" style="width: 100%; max-height: 68px; object-fit: contain;">
        </div>
    </div>
    <div style="border-bottom: 2px solid #CC071A; padding: 2px 0px; text-align: left; width:100%;">
        <p style="margin: 2px 0; font-size: 14px;">
        Publish Date ${currentDate}
        </p>
    </div>
    <table>
        <colgroup>
        <col style="width: 4%">
        <col style="width: 17%">
        <col style="width: 8%">
        <col style="width: 19%">
        <col style="width: 6%">
        <col style="width: 11%">
        <col style="width: 18%">
        <col style="width: 8%">
        <col style="width: 9%">
        </colgroup>
        <thead style="background: #CC071A;color: #fff;">
        <tr>
            <th style="text-align: left;">Sr.no</th>
            <th style="text-align: left;">Name</th>
            <th style="text-align: left;">Lot No</th>
            <th style="text-align: left;">Maker</th>
            <th style="text-align: left;">Year</th>
            <th style="text-align: left;">Bid</th>
            <th style="text-align: left;">City Date and time</th>
            <th style="text-align: left;">Grouped</th>
            <th style="text-align: left; text-decoration: underline;">Result</th>
        </tr>
        </thead>
        <tbody>
        ${tableRows}
        </tbody>
    </table>


    </body>
    </html>`;
};
export default UserPDF;
